import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api.js';
import { useScopeKey } from './useScopeKey.js';

const QUERY_KEY = ['cash-flow-layout'];

/**
 * Layout (ordre + soldes intermédiaires) du tableau cash-flow.
 * Un layout par société, plus un layout propre à la vue groupe (résolu côté
 * backend selon le périmètre de session). La clé inclut le périmètre pour ne
 * jamais servir le layout d'une société à une autre.
 */
export function useCashFlowLayout() {
  const scopeKey = useScopeKey();
  return useQuery({
    queryKey: [...QUERY_KEY, scopeKey],
    queryFn: () => api.get('/cash-flow/layout'),
    staleTime: 60_000,
    select: (data) => data?.rows ?? [],
    enabled: scopeKey !== 'loading',
  });
}

export function useSaveCashFlowLayout() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (rows) => api.put('/cash-flow/layout', { rows }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
}
